import {
	ChangeDetectionStrategy,
	Component,
	computed,
	inject,
	input,
} from '@angular/core';
import { DropdownItem } from '@ui/dropdown/dropdown.component';
import { PortalInvite, PortalInvitee } from '@models/portal-invites';
import { ModalService } from '@ui/modal/modal.service';
import { SnackbarService } from 'src/app/shared/services/ui/snackbar.service';
import { UI_TYPES } from 'src/app/ui/modal/modal.types';
import { RemoveContactAccessModalComponent } from '../remove-contact-access-modal/remove-contact-access-modal.component';
import { UpdateClientEmailModalComponent } from '../update-client-email-modal/update-client-email-modal.component';
import { AtomicModule } from 'src/app/shared/atomic/atomic.module';
import { UiModule } from 'src/app/ui/ui.module';
import { TablerIconComponent } from 'angular-tabler-icons';
import { RemoveInvitees } from 'src/app/shared/state/portal-invite/portal-invite.actions';
import { dispatch } from '@ngxs/store';
import { TestHookDirective } from '@core/ui';
import { TestHooks } from './intake-client-pill.hooks';
import {
	AnalyticsEvent,
	AnalyticsService,
} from '@services/analytics/analytics.service';

@Component({
	selector: 'app-intake-client-pill',
	templateUrl: './intake-client-pill.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: true,
	imports: [UiModule, AtomicModule, TablerIconComponent, TestHookDirective],
})
export class IntakeClientPillComponent {
	testHooks = TestHooks;
	invitee_ = input.required<PortalInvitee>();
	portalInvite_ = input.required<PortalInvite>();

	private modalService = inject(ModalService);
	private snackbarService = inject(SnackbarService);
	private analyticsService = inject(AnalyticsService);

	private removeInvitees = dispatch(RemoveInvitees);

	kebabOptions_ = computed<DropdownItem[]>(() => [
		{
			id: 'remove',
			title: { label: 'Remove', icon: 'trash' },
			action: () => this.removeInvitee(),
		},
	]);

	removeInvitee() {
		const invitee = this.invitee_();
		this.modalService.openModal(RemoveContactAccessModalComponent, {
			title: 'Remove Contact Access',
			size: 'sm',
			type: UI_TYPES.DANGER,
			primaryAction: {
				text: 'Remove Access',
				action: () => {
					// TODO: add logic to deactivate the invitee's link instead of removing them
					this.removeInvitees({
						inviteId: this.portalInvite_().id,
						invitees: [invitee],
					});

					this.analyticsService.logEvent(
						AnalyticsEvent.INTAKE_PARTIES_INTAKE_OVERVIEW_SHARE_REMOVE,
					);

					this.snackbarService.openSnackBar({
						text: `${invitee?.name} access has been removed`,
						type: 'success',
					});

					this.modalService.closeModal();
				},
			},
			data: { invitee },
		});
	}

	updateClientEmail() {
		const invitee = this.invitee_();
		this.modalService.openModal(UpdateClientEmailModalComponent, {
			title: 'Update Client Email',
			size: 'sm',
			type: UI_TYPES.DANGER,
			data: { invitee, inviteId: this.portalInvite_().id },
		});
	}
}
